import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canAccessOrionAppsList = defineAbilityConfig({
  // Importing the constant would introduce a circular dependency (import {ORION_APPS_LIST_PANEL} from '@packages/systems/designer/panels';)
  visiblePanels: ['orion-apps-list'], // Only when Orion Apps List panel is visible
} as const);
